import { Backdrop, ObjectType } from '@/@types/graphql-types';

export interface ModalOptions {
	component: any;
	componentProps?: any;
	presentingElement?: HTMLElement;
	showBackdrop?: boolean;
	backdropDismiss?: boolean;
	cssClass?: string | string[];
	classes?: string | string[];
	delegate?: any;
	animated?: boolean;
	swipeToClose?: boolean;
	mode?: 'ios' | 'md';
	keyboardClose?: boolean;
	id?: string;
	htmlAttributes?: any;
	enterAnimation?: any;
	leaveAnimation?: any;
}

export const MarkAsSeenModalOptions: Omit<ModalOptions, 'component'> = {
	backdropDismiss: true,
	cssClass: 'mark-as-seen-modal',
	swipeToClose: true,
	id: 'mark-as-seen-modal',
};

export interface MarkAsSeenModalProps {
	titleId: string;
	titleObjectType: ObjectType;
	titleObjectId: number;
	titleName?: string;
	seenEpisodeCount?: number;
	posterUrl?: string;
	backdrops: Pick<Backdrop, 'backdropUrl'>[];
}

export enum MarkAsSeenEvent {
	VIEW = 'view',
	DONE = 'done',
}

export enum MarkAsSeenView {
	PROMPT = 'prompt',
	SEEN_EPISODES = 'seen-episodes',
	SUCCESS = 'success',
}

export enum MarkAsSeenPromptViewEvent {
	ALL = 'all',
	NONE = 'none',
	SOME = 'some',
}
